module.exports = __webpack_public_path__ + "site-build/img/search-line_white.4228d38b.svg";